import React, { useMemo } from "react";
import FormField from "../FormField";
import classNames from "classnames";
import { SelectFieldProps } from "../types";
import "./styles.scss";

export const SelectField = ({
  t,
  field,
  register,
  touchedFields,
  errors,
  watch,
  className: classNameProp,
  dynamicValidation,
  nextStepTriggerCount,
}: SelectFieldProps) => {
  const dataQA = `${field.type}-${field.name}`;
  const selectID = field.id || field.name;

  const className = classNames("select", {
    [field.class as string]: typeof field.class === "string" && field.class.length > 0,
    [classNameProp as string]: classNameProp,
  });

  const selectValue = watch(field.name);

  const shouldShowError =
    Boolean(errors[field.name]) &&
    (nextStepTriggerCount === undefined ||
      Boolean(touchedFields?.[field.name]) ||
      nextStepTriggerCount > 0);
  const validate = !shouldShowError || !errors[field.name];
  const validField = touchedFields?.[field?.name] && !errors[field.name];

  const selectClassName = useMemo(
    () => `
      select-input
      ${selectValue ? "regular-options" : "grey-option"}
    `,
    [selectValue]
  );

  return (
    <FormField
      id={selectID}
      label={t[field.label]}
      subLabel={field.subLabel && t[field.subLabel]}
      className={className}
      name={field.name}
      errorMessage={shouldShowError ? t[errors[field.name]?.message as string] : undefined}
      tooltip={field.tooltip && t[field.tooltip]}
      validate={validate}
      validField={validField}>
      <select
        id={selectID}
        data-qa={dataQA}
        className={selectClassName}
        {...register(field.name, dynamicValidation ?? field.validation)}>
        <option value="">
          {(field.placeholder && t[field.placeholder]) || t["Select an option"]}
        </option>
        {field.options?.map((option, index) => {
          const dataTestId = `select-input-${option.name}`;
          return (
            <option
              id={dataTestId}
              data-testid={dataTestId}
              className="regular-options"
              value={option.value}
              key={index}>
              {(option.name && t[option.name]) || option.name}
            </option>
          );
        })}
      </select>
    </FormField>
  );
};
